import { userFeedbackQuery } from 'Shared/FeedbackBanner/__generated__/userFeedbackQuery';

export const getFeedbackFormLink = (
  surveyLink: string,
  data?: userFeedbackQuery,
): string => {
  const params = new URLSearchParams();
  if (data?.user) {
    params.append('user_id', encodeURIComponent(data.user.id));

    if (data.user.organisation?.subDomain) {
      params.append(
        'domain',
        encodeURIComponent(data.user.organisation.subDomain),
      );
    }

    // This is the location that is configurable in the users account menu
    if (data.user.locationData?.name) {
      params.append('country', encodeURIComponent(data.user.locationData.name));
    }

    if (data.user.userType?.name) {
      params.append('usertype', encodeURIComponent(data.user.userType.name));
    }
  }

  params.append('platform', 'web');

  return `${surveyLink}#${params.toString()}`;
};
